import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

export default function Header() {
  return (
    <div className="Header">
      <h1 className="h1-pacifico">My Weather App</h1>
    </div>
  );
}
